import script from "./DocumentMagnifierPreview.vue?vue&type=script&setup=true&lang=js"
export * from "./DocumentMagnifierPreview.vue?vue&type=script&setup=true&lang=js"

import "./DocumentMagnifierPreview.vue?vue&type=style&index=0&id=c40b2dd8&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c40b2dd8"]])

export default __exports__